import { render, staticRenderFns } from "./BadgeCampaignSpaceStatus.vue?vue&type=template&id=9acb4ada"
import script from "./BadgeCampaignSpaceStatus.vue?vue&type=script&lang=js"
export * from "./BadgeCampaignSpaceStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports